/* @flow */
import * as React from 'react';

const Boombox = props => (
  <svg
    width={130}
    height={83}
    viewBox="0 0 130 83"
    strokeWidth={1}
    fillRule="evenodd"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path
      stroke="none"
      fill="#E7EBF6"
      d="M85.84,3.208 C90.904,3.208 95.01,7.313 95.01,12.378 L95.01,19.142 L89.232,19.142 L89.232,12.735 C89.232,10.581 87.486,8.834 85.331,8.834 L79.811,8.834 L34.127,8.834 L28.607,8.834 C26.452,8.834 24.706,10.581 24.706,12.735 L24.706,19.142 L18.928,19.142 L18.928,12.378 C18.928,7.313 23.033,3.208 28.098,3.208 L33.474,3.208 L80.461,3.208 L85.84,3.208 Z"
    />
    <polygon
      stroke="none"
      fill="#DEDEDE"
      points="8.418 81.162 105.52 81.162 105.52 76.079 8.418 76.079"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M112.438,52.611 C112.438,48.367 111.306,44.389 109.335,40.954 L109.335,21.142 C109.335,20.038 108.44,19.142 107.335,19.142 L6.603,19.142 C5.498,19.142 4.603,20.038 4.603,21.142 L4.603,40.954 C2.633,44.39 1.5,48.367 1.5,52.611 C1.5,56.855 2.633,60.833 4.603,64.268 L4.603,74.08 C4.603,75.184 5.498,76.08 6.603,76.08 L107.335,76.08 C108.44,76.08 109.335,75.184 109.335,74.08 L109.335,64.268 C111.306,60.833 112.438,56.855 112.438,52.611 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M33.474,3.208 L28.098,3.208 C23.034,3.208 18.928,7.313 18.928,12.378 L18.928,19.142 L95.01,19.142 L95.01,12.378 C95.01,7.313 90.905,3.208 85.84,3.208 L80.461,3.208"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M34.127,8.834 L28.607,8.834 C26.452,8.834 24.706,10.581 24.706,12.735 L24.706,19.142 L89.232,19.142 L89.232,12.735 C89.232,10.581 87.485,8.834 85.331,8.834 L79.811,8.834"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M75.755,1.5 L38.183,1.5 C35.583,1.5 33.475,3.608 33.475,6.208 L33.475,6.208 C33.475,8.808 35.583,10.916 38.183,10.916 L75.755,10.916 C78.355,10.916 80.463,8.808 80.463,6.208 L80.463,6.208 C80.463,3.608 78.355,1.5 75.755,1.5"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M75.755,1.5 L38.183,1.5 C35.583,1.5 33.475,3.608 33.475,6.208 L33.475,6.208 C33.475,8.808 35.583,10.916 38.183,10.916 L75.755,10.916 C78.355,10.916 80.463,8.808 80.463,6.208 L80.463,6.208 C80.463,3.608 78.355,1.5 75.755,1.5 Z"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M88.969,36.06 C79.828,36.06 72.418,43.47 72.418,52.611 C72.418,61.752 79.828,69.162 88.969,69.162 C98.11,69.162 105.52,61.752 105.52,52.611 C105.52,43.47 98.11,36.06 88.969,36.06"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M24.969,36.06 C15.828,36.06 8.418,43.47 8.418,52.611 C8.418,61.752 15.828,69.162 24.969,69.162 C34.11,69.162 41.52,61.752 41.52,52.611 C41.52,43.47 34.11,36.06 24.969,36.06"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M105.52,52.611 C105.52,43.47 98.11,36.06 88.969,36.06 C79.828,36.06 72.418,43.47 72.418,52.611 C72.418,61.752 79.828,69.162 88.969,69.162 C98.11,69.162 105.52,61.752 105.52,52.611 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M100.468,52.611 C100.468,46.26 95.32,41.112 88.969,41.112 C82.619,41.112 77.471,46.26 77.471,52.611 C77.471,58.962 82.619,64.11 88.969,64.11 C95.32,64.11 100.468,58.962 100.468,52.611 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M41.52,52.611 C41.52,43.47 34.11,36.06 24.969,36.06 C15.828,36.06 8.418,43.47 8.418,52.611 C8.418,61.752 15.828,69.162 24.969,69.162 C34.11,69.162 41.52,61.752 41.52,52.611 Z"
    />
    <path
      stroke="#1C1F34"
      strokeWidth={1.5}
      d="M36.468,52.611 C36.468,46.26 31.32,41.112 24.969,41.112 C18.619,41.112 13.471,46.26 13.471,52.611 C13.471,58.962 18.619,64.11 24.969,64.11 C31.32,64.11 36.468,58.962 36.468,52.611 Z"
    />
    <polygon
      stroke="none"
      fill="#E8EBF7"
      points="47.33 69.445 66.609 69.445 66.609 54.602 47.33 54.602"
    />
    <polygon
      stroke="#1C1F34"
      strokeWidth={3}
      points="47.33 69.445 66.609 69.445 66.609 54.602 47.33 54.602"
    />
    <path
      stroke="none"
      fill="#677BC5"
      d="M100.912,24.933 L13.026,24.933 C11.688,24.933 10.603,26.018 10.603,27.356 L10.603,28.081 C10.603,29.42 11.688,30.504 13.026,30.504 L100.912,30.504 C102.25,30.504 103.335,29.42 103.335,28.081 L103.335,27.356 C103.335,26.018 102.25,24.933 100.912,24.933"
    />
    <path stroke="#FFFFFF" strokeWidth={3} d="M76.676,25.296 L76.676,30.142" />
    <path
      stroke="#1C1F34"
      strokeWidth={3}
      d="M100.912,24.933 L13.026,24.933 C11.688,24.933 10.603,26.018 10.603,27.356 L10.603,28.081 C10.603,29.42 11.688,30.504 13.026,30.504 L100.912,30.504 C102.25,30.504 103.335,29.42 103.335,28.081 L103.335,27.356 C103.335,26.018 102.25,24.933 100.912,24.933 Z"
    />
    <path stroke="#677BC5" d="M53,44.985 L53,36.296" />
    <path stroke="#677BC5" d="M47,44.985 L47,36.296" />
    <path stroke="#677BC5" d="M60,44.985 L60,36.296" />
    <path stroke="#677BC5" d="M66,44.985 L66,36.296" />
    <polygon
      stroke="#1C1F34"
      strokeWidth={3}
      points="8.418 81.162 105.52 81.162 105.52 76.079 8.418 76.079"
    />
    <path
      stroke="none"
      fill="#1C1F34"
      d="M119.491,0.797 C118.221,0.229 116.921,0.228 116.921,0.228 L116.921,2.608 L116.921,10.483 C116.615,10.398 116.299,10.336 115.965,10.336 C114.017,10.336 112.438,11.915 112.438,13.863 C112.438,15.809 114.017,17.389 115.965,17.389 C117.912,17.389 119.491,15.809 119.491,13.863 L119.491,6.958 L119.491,5.548 L119.491,3.881 L126.612,9.534 L126.612,10.152 L126.612,18.029 C126.306,17.942 125.99,17.881 125.656,17.881 C123.709,17.881 122.13,19.459 122.13,21.407 C122.13,23.355 123.709,24.933 125.656,24.933 C127.604,24.933 129.182,23.355 129.182,21.407 L129.182,14.502 L129.182,13.092 L129.182,8.341 L119.491,0.797 Z"
    />
  </svg>
);

export default Boombox;



// WEBPACK FOOTER //
// ./src/assets/images/icons/boombox.js